import { Router } from 'framework7/types';
import { ServicePage } from '@/components/pages/Service/ServicePage';
import { ServicesAllPage } from '@/components/pages/ServicesAll/ServicesAllPage';
import { paths } from '@/config/paths';

export const serviceRoutes: Router.RouteParameters[] = [
  {
    path: paths.service,
    component: ServicePage,
    name: 'サービス',
  },
  {
    path: paths.servicesAll,
    component: ServicesAllPage,
    name: 'サービス一覧',
  },
  {
    path: paths.serviceCategory(':id'),
    component: ServicePage,
    name: 'サービスカテゴリー',
  },
];
